import fill from 'lodash/fill'

export default (value, { maxLength }) => {
  const arr =  fill(Array(maxLength), '9')

  return arr.join('')
}
